import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength } from '@vuelidate/validators'
import Axios from "axios";
//INCRIPTACION
import CryptoJS from "crypto-js";
import { EncryptService } from '../../utils/encrypthService';


export default {

  components: {

  },
  setup() {
    return { v$: useVuelidate() }
  },
  name: "Login",



  data() {
    return {
      loading: false,
      login: {
        nit: "",
        password: ""
      }
    };
  },
  validations() {
    return {
      login: {
        nit: {
          required, min: minLength(1), max: maxLength(13)
        },
        password: {
          required,
          // min: minLength(8)
        }
      }
    }
  },
  methods: {
    async auth() {
      // busca la variable de entorno con la clave pública

      const encryptService = new EncryptService();
      const encrypteNit = encryptService.encrypt(this.login.nit);
      const encryptedPassword = encryptService.encrypt(this.login.password);

      const data = {
        nit: encrypteNit,
        password: encryptedPassword
      };

      sessionStorage.removeItem("CARD_INFO");
      sessionStorage.removeItem("CARD_REQUEST");
      this.loading = true;
      try {

        let r = await this.$store.state.services.loginService.postLogin(data);
        // console.log("Login");
        // console.log(r);
        if (r.data.success) {
          this.$toast.success("Bienvenido")
          let data = r.data.data

          console.log("data");
          console.log(data);
          //incriptacion de datos y token de autorización
          let clave_token_autorizacion = "dsgfv/&#$%sdksdn..sd5454sd-tic"//nombre en sessión storage
          let clave_data = "dsgfv/&#$%sdksdn..sd5454sd-todo" //nombre en sessión storage
          sessionStorage.setItem(clave_token_autorizacion, btoa(data.token));
          sessionStorage.setItem(clave_data, CryptoJS.AES.encrypt(JSON.stringify(data), data.token + "byTeamT0d0T1c").toString());
          //guardamos el token authorization en el header para inicializar el acceso a los servicios
          Axios.defaults.headers.common.Authorization = `Bearer ${data.token}`
          Axios.defaults.headers.common.Accept = 'application/json'
          // Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
          this.loading = false;

          if (data.rol.includes(1)) {
            //console.log("Administrador");
            let url = "/administrador"
            this.$router.push({ path: url });
          } else if (data.rol.includes(2) || data.rol.includes(4)) {
            //console.log("Empleado");
            let url = "/empleado"
            this.$router.push({ path: url });
          } else if (data.rol.includes(3)) {
            //console.log("Usuario");
            let url = "/usuario_final"
            this.$router.push({ path: url });
          } else if (data.rol.includes(5) || data.rol.includes(6)) {
            //console.log("Cliente");
            let url = "/gestor"
            this.$router.push({ path: url });
          }
        } else {
          this.loading = false;
          this.$toast.error("Usuario y/o Contraseña incorrectos")
        }
      } catch (error) {
        this.loading = false;
        this.$toast.error("Usuario y/o Contraseña incorrectos")
      }
    }
  },

  computed: {
    size() {
      const size = { sm: 'medium', md: 'large', lg: 'large' }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {}
    }
  }
};